<script setup>
import { computed } from 'vue';
import BaseBubble from './Base.vue';
import { useI18n } from 'vue-i18n';
import { CONTENT_TYPES } from '../constants.js';
import { useMessageContext } from '../provider.js';
import { useInbox } from 'dashboard/composables/useInbox';

const { content, contentAttributes, contentType } = useMessageContext();
const { t } = useI18n();
const { isAWebWidgetInbox } = useInbox();

const formValues = computed(() => {
  if (contentType.value === CONTENT_TYPES.FORM) {
    const { items, submittedValues = [] } = contentAttributes.value;

    if (submittedValues.length) {
      return submittedValues.map(submittedValue => {
        const item = items.find(
          formItem => formItem.name === submittedValue.name
        );
        return {
          title: submittedValue.value,
          value: submittedValue.value,
          label: item?.label,
        };
      });
    }

    return [];
  }

  if (contentType.value === CONTENT_TYPES.INPUT_SELECT) {
    const [item] = contentAttributes.value?.submittedValues ?? [];
    if (!item) return [];

    return [
      {
        title: item.title,
        value: item.value,
        label: '',
      },
    ];
  }

  return [];
});

const sentOptions = computed(() => {
  if (contentType.value !== CONTENT_TYPES.INPUT_SELECT) return [];
  if (isAWebWidgetInbox.value) return [];
  return (contentAttributes.value?.items ?? [])
    .map(item => item.title)
    .filter(Boolean);
});
</script>

<template>
  <BaseBubble class="px-4 py-3" data-bubble-name="csat">
    <span v-dompurify-html="content" :title="content" />
    <div v-if="sentOptions.length" class="opcoes-enviadas space-y-2 pt-2 mt-3">
      <div
        v-for="(option, index) in sentOptions"
        :key="index"
        class="opcao-enviada w-full px-4 py-2 rounded-lg text-sm text-center cursor-default"
      >
        {{ option }}
      </div>
      <div class="opcoes-aviso text-xs text-center italic">
        {{ t('CONVERSATION.INTERACTIVE.BUTTONS_READ_ONLY') }}
      </div>
    </div>
    <dl v-if="formValues.length" class="mt-4">
      <template v-for="item in formValues" :key="item.title">
        <dt class="text-n-slate-11 italic mt-2">
          {{ item.label || t('CONVERSATION.RESPONSE') }}
        </dt>
        <dd>{{ item.title }}</dd>
      </template>
    </dl>
    <div v-else-if="isAWebWidgetInbox" class="my-2 font-medium">
      {{ t('CONVERSATION.NO_RESPONSE') }}
    </div>
  </BaseBubble>
</template>

<style scoped>
.opcoes-enviadas {
  border-top: 1px solid color-mix(in srgb, currentColor 25%, transparent);
}
.opcao-enviada {
  color: inherit;
  font-weight: 500;
  background: color-mix(in srgb, currentColor 10%, transparent);
  border: 1px solid color-mix(in srgb, currentColor 30%, transparent);
}
.opcoes-aviso {
  color: inherit;
  opacity: 0.7;
}
</style>
